import { Field } from "formik";
import FormikTextField from "../../../components/Common/FormikTextField";
import { MenuItem, TextField } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import AddressField from "./AddressField";
import { usePortal } from "../../../Providers/PortalProvider";

const ShippingFormUS = ({ options, values, handleChange }) => {
  const { t } = useTranslation();
  const { locale } = usePortal();

  return (
    <>
      <Field
        id="shipping-form-name"
        component={FormikTextField}
        label={t("Name")}
        name="name"
      />

      <AddressField />

      {options.gatherAddress2 && (
        <Field
          id="shipping-form-address-2"
          component={FormikTextField}
          label={t("Address 2")}
          name="address2"
          autoComplete="address-line2"
        />
      )}

      <Field
        id="shipping-form-city"
        component={FormikTextField}
        label={t("City")}
        name="city"
      />

      {options.gatherState && !options.states && (
        <Field
          id="shipping-form-state"
          component={FormikTextField}
          label={t("State")}
          name="state"
        />
      )}

      {options.gatherState && options.states && (
        <TextField
          id="shipping-form-state"
          select
          label={t("State")}
          name="state"
          value={values.state}
          onChange={handleChange("state")}
          margin="normal"
          fullWidth
        >
          {Object.keys(options.states)
            .filter((key) => key != "")
            .map((key) => {
              const value = options.states[key];
              return (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              );
            })}
        </TextField>
      )}

      <Field
        id="shipping-form-postal-code"
        component={FormikTextField}
        label={t("Zip code")}
        name="postalCode"
      />

      {options.showDisabledDeliveryCountry && (
        <Field
          id="shipping-form-country"
          component={FormikTextField}
          label={t("Country")}
          name="country"
          value={locale.country.name}
          disabled={true}
        />
      )}
    </>
  );
};

export default ShippingFormUS;
